import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryUserService {

  constructor(private _httpClient: HttpClient) { }

  getAllInventoryUsersWithPagination(inventoryId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean,
    filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('inventoryId', inventoryId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryUser.GetAllInventoryUsersWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsInventoryUser(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryUser.GetColumnsInventoryUserAsync}`);
  }

  saveInventoryUser(inventoryId: number, userId: number): Observable<any> {
    const params = new HttpParams().set('inventoryId', inventoryId).set('userId', userId);
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryUser.SaveInventoryUserAsync}`,
      { params: params })
  }
}
